// extracted by mini-css-extract-plugin
export default {"tabs":"resources_tabs__Webez"};